import React, { useState } from "react";
import { HiOutlineSpeakerWave } from "react-icons/hi2"; // Audio icon from react-icons
import { SlArrowDown } from "react-icons/sl";

interface LanguageSelectorProps {
  selectedLanguage: string;
  onLanguageChange: (language: string) => void;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  selectedLanguage,
  onLanguageChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [language, setLanguage] = useState(selectedLanguage);

  const languages = [
    { value: "en", label: "English" },
    { value: "kn", label: "Kannada" },
    { value: "hi", label: "Hindi" },
    { value: "ta", label: "Tamil" },
    { value: "te", label: "Telugu" },
  ];

  const handleLanguageChange = (languageValue: string) => {
    const selected = languages.find((lang) => lang.value === languageValue);
    if (selected) {
      setLanguage(languageValue);
      onLanguageChange(languageValue);
      localStorage.setItem("audioLanguage", languageValue);
      setIsOpen(false);
    }
  };

  return (
    <div
      className="flex items-center relative inline-block p-2 rounded-full"
      style={{ background: "rgba(0, 0, 0, 0.1)" }}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center  w-36 text-gray-700 rounded-lg "
      >
        <div className="flex bg-white rounded-full h-8 w-8 items-center justify-center mr-2">
          <HiOutlineSpeakerWave className=" h-6 w-6" size={20} />
        </div>
        <span className="capitalize text-black font-semibold">
          {languages.find((lang) => lang.value === language)?.label}
        </span>
      </button>

      {isOpen && (
        <ul className="absolute right-0 bottom-14 z-10 w-[11rem] bg-white border border-gray-300 rounded-lg ">
          {languages.map((lang) => (
            <li
              key={lang.value}
              onClick={() => handleLanguageChange(lang.value)}
              className="flex items-center px-4 py-2 cursor-pointer hover:bg-gray-100"
            >
              <span className="capitalize">{lang.label}</span>
            </li>
          ))}
        </ul>
      )}
      {isOpen && <SlArrowDown className="!text-black mr-2" />}
      {!isOpen && <SlArrowDown className="!text-black mr-2 rotate-180" />}
    </div>
  );
};

export default LanguageSelector;

// import React, { useState } from 'react';

// interface LanguageSelectorProps {
//   selectedLanguage: string;
//   onLanguageChange: (language: string) => void;
// }

// const LanguageSelector: React.FC<LanguageSelectorProps> = ({ selectedLanguage, onLanguageChange }) => {
//    const [language, setLanguage] =  useState(selectedLanguage)
//   return (
//     <select className='w-28' value={language} onChange={(e) => {
//         onLanguageChange(e.target.value)
//         localStorage.setItem("audioLanguage", e.target.value)
//         setLanguage(e.target.value)
//     }}>
//       <option value="en">English</option>
//       <option value="kn">Kannada</option>
//       <option value="hi">Hindi</option>
//       <option value="ta">Tamil</option>
//       <option value="te">Telugu</option>
//     </select>
//   );
// };

// export default LanguageSelector;
